import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Footer from './components/layout/Footer';
import Header from './components/layout/Header';
import RouteMetadata from './components/layout/RouteMetadata';
import ScrollManager from './components/layout/ScrollManager';
import { ThemeProvider } from './components/theme/ThemeProvider.jsx';
import { LanguageProvider, useTranslation } from './i18n/LanguageProvider.jsx';
import NotFound from './components/layout/NotFound';
import { routesConfig } from './routes';

import './css/utilities.css';
import './css/main.css';
import './css/site-theme.css';

function SkipLabel() {
  const { isPortuguese } = useTranslation();
  return <>{isPortuguese ? 'Pular para o conteúdo' : 'Skip to content'}</>;
}

function App() {
  return (
    <div className="site-shell d-flex flex-column min-vh-100">
      <ThemeProvider>
        <LanguageProvider>
          <Router>
            <a className="skip-link" href="#main-content">
              <SkipLabel />
            </a>
            <ScrollManager />
            <RouteMetadata />
            <Header />
            <main id="main-content" tabIndex={-1} className="container site-content col">
              <Routes>
                {routesConfig
                  .filter(({ href }) => !href)
                  .map(({ path, component: Component }) => (
                    <Route key={path} path={path} element={<Component />} />
                  ))}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
